import * as THREE from 'three';

const DEFAULT_FADE_SECONDS = 0.35;

export const handleAnimationTransition = (
    actions: any,
    animationName: string,
    options?: { alsoPlay?: string[]; fadeSeconds?: number }
) => {
    const alsoPlay = options?.alsoPlay ?? [];
    const fade = options?.fadeSeconds ?? DEFAULT_FADE_SECONDS;
    const keepPlaying = new Set<string>([animationName, ...alsoPlay]);

    const currentlyPlaying: any[] = [];
    for (const name in actions) {
        const action = actions[name];
        if (!action) continue;
        if (action.isRunning?.() && action.getEffectiveWeight?.() > 0.01 && !keepPlaying.has(name)) {
            currentlyPlaying.push(action);
        }
    }

    for (const name in actions) {
        const action = actions[name];
        if (!action) continue;

        if (keepPlaying.has(name)) {
            action.enabled = true;
            action.setLoop(THREE.LoopRepeat, Infinity);
            action.clampWhenFinished = false;
            action.setEffectiveTimeScale(1);

            if (action.isRunning?.() && action.getEffectiveWeight?.() > 0.01) {
                action.stopFading?.();
                action.setEffectiveWeight(1);
                continue;
            }

            action.stopFading?.();
            action.reset();
            action.play();
            action.setEffectiveWeight(1);

            const fadingFrom = currentlyPlaying.find((a) => a !== action);
            if (fadingFrom) {
                fadingFrom.stopFading?.();
                action.crossFadeFrom(fadingFrom, fade, false);
            } else {
                action.fadeIn(fade);
            }
        }
    }
};
